import { SELECTED_AUDIT_OPTIONS_SAVE, SELECTED_AUDIT_OPTIONS_CLEAR } from '../../../actions/constants/types';

const initialAuditState = {
  options: [],
  dateFrom: undefined,
  dateTo: undefined,
};

function audit(state = initialAuditState, action) {
  switch (action.type) {
    case SELECTED_AUDIT_OPTIONS_SAVE: {
      return {
        ...state,
        ...action.data,
      };
    }
    case SELECTED_AUDIT_OPTIONS_CLEAR: {
      return {
        initialAuditState,
      };
    }
    default:
      return state;
  }
}

export default audit;
